<form>
  <div class="row mt-3">
    <div class="col-md-8 mt-3 offset-md-2">
      <div class="row mb-2">
        <h4 class="title"><i class="fa fa-wrench"></i> {{title | translate}}</h4>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-9">
          <h5>{{ "TITLE.STATIC-DATA-RELOADING" | translate }}</h5>
          {{ "MESSAGE.PERMITS-RELOADING-DATA-USE-IN-APPLICATION" | translate }}
          <ul class="font-weight-bold">
            <li>{{ "LABEL.STATES" | translate }}</li>
            <li>{{ "LABEL.FONT-COLORS" | translate }}</li>
            <li>{{ "LABEL.FONT-SIZES" | translate }}</li>
            <li>{{ "LABEL.FONT-TYPES" | translate }}</li>
            <li>{{ "LABEL.PAGINATION-TYPES" | translate }}</li>
            <li>{{ "LABEL.CONTENT-POSITIONS-BACK-AND-FRONT" | translate }}</li>
            <li>{{ "LABEL.FLOW-TYPES" | translate }}</li>
            <li>{{ "LABEL.PARTICIPANT-TYPES" | translate }}</li>
            <li>{{ "LABEL.PERSON-TYPES" | translate }}</li>
            <li>{{ "LABEL.IDENTIFICATION-DOCUMENTS-TYPES" | translate }}</li>
            <li>{{ "LABEL.OPERATION-TYPES" | translate }}</li>
            <li>{{ "LABEL.MODULE-LIST" | translate }}</li>
          </ul>
        </div>
        <div class="col-md-3">
          <div class="form-row">
            <div class="form-group col">
              <button type="button" class="btn btn-outline-success w-100 font-weight-bold" (click)="reload()">
                <i class="fas fa-sync-alt"></i> {{ "BUTTON.RELOAD" | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<app-loading *ngIf="loading"></app-loading>
